import { useEffect, useRef, useState } from 'react';
import WebUniversal, { WUExtendPropsType } from '../../../system/WebUniversalNewEx'
import { columnsheadId } from '../../../universal/columnshead';
import dayjs from 'dayjs';
import { Button, Input, Space, Tooltip, Typography, Image } from 'antd';
import fetchApi from '../../../../utils/api/fetchApi';
import antMessage from '../../../../utils/extend/AntdNotification';
import { MsgStringType } from "../../../../utilsTs/declareApplicationTypes";
import stringHandle from '../../../../utilsTs/baseLib/stringHandle';

/**
 * 组件 
 * @param props 
 * @returns 
 */
const Web = (props: any) => {
    const { Paragraph } = Typography;
    const apiId = 'customerServiceMessage';
    const { data } = props;
    const { customerServiceId } = data;

    //刷新变量
    const [refresh, setRefresh] = useState(0);
    /** 可使用WebUniversal(父)组件函数 */
    const ref = useRef<any>(undefined);
    const [inputValue, setInputValue] = useState('');
    const [defaultService, setDefaultService] = useState('');
    const [initData, setInitData] = useState<any>();

    useEffect(() => {
        if (ref.current) {
            setInitData(() => ref.current.initData);
            setDefaultService(ref.current.defaultService);
            if (refresh !== 0) {
                ref.current.initData();
            }
        }
        // const fetchData = async () => {
        // };
        // fetchData();

    }, [refresh]); //初始化数据

    /** 表头内容 */
    const columnsHead = [
        {
            title: '发送/接收',
            dataIndex: 'isSendOrReceive',
            render: (text: any) => (
                text === 0 ? <p style={{ color: 'yellow' }}>发送</p> : '接收'
            )
        },
        {
            title: '时间',
            dataIndex: 'id',
            render: (text: any, record: any) => (
                dayjs(record.sysDate.createdAt).format('YYYY-MM-DD HH:mm:ss')
            )
        },
        {
            title: '类型',
            dataIndex: 'msgType',
            render: (val: any) => val?.name
        },
        {
            title: '内容',
            dataIndex: 'contents',
            render: (val: any, record: any) => {
                switch (record.msgTypeId) {
                    case 'image':
                        if (val) {
                            const { MediaId, PicUrl } = JSON.parse(val);
                            console.log(JSON.parse(val));

                            // const { wxAccountId } = record?.customerService?.customerServiceOperator;
                            // const res = await fetchApi.GET(defaultService, {
                            //     apiId: 'wxMaterial',
                            //     apiExtend: 'getMedia',
                            //     apiData: {
                            //         wxAccountId,
                            //         mediaId: MediaId
                            //     }
                            // })
                            // console.log(res.data.data);
                            // stringHandle.blobToBase64(res.data).then(
                            //     res => {
                            //         console.log(res);

                            //     }
                            // )



                            return (
                                <Image
                                    src={PicUrl}
                                    width={60}
                                    alt={record.msgId} />)
                        }
                        break;
                    default:
                        return (<Tooltip placement="topLeft" title={
                            <Paragraph style={{ whiteSpace: 'pre-wrap' }}>
                                {`msgId: ${record.msgId}；\n${val}`}
                            </Paragraph>
                        }>{
                                (typeof val !== "undefined" && val !== null) ?
                                    (val.length >= 8 ? val.substring(0, 8) + '......' : val)
                                    : ''
                            }</Tooltip>)
                        break;
                }
            }
        },
        {
            title: '接入id',
            dataIndex: 'accessId',
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 8) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '发送/转发',
            dataIndex: 'isSendSuccess',
            render: (text: any, record: any) => {
                return (<>
                    {record?.isSendSuccess === true ?
                        <Tooltip placement="topLeft"
                            title={<Paragraph style={{ whiteSpace: 'pre-wrap' }}>
                                {`时间: ${dayjs(record.sendSuccessDate).format('YYYY-MM-DD HH:mm:ss')}`}
                            </Paragraph>}>
                            <p style={{ color: 'greenyellow' }}>发送成功</p> </Tooltip> : ''}
                    {record?.isForward === true ?
                        <Tooltip placement="topLeft"
                            title={<Paragraph style={{ whiteSpace: 'pre-wrap' }}>
                                {`时间: ${dayjs(record.forwardDate).format('YYYY-MM-DD HH:mm:ss')}`}
                            </Paragraph>}>
                            <p>转发成功</p> </Tooltip> : ''}
                </>
                )
            }
        }
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const sendCustomMessage = () => {
        if (inputValue !== '') {
            fetchApi.POST(defaultService, {
                apiId: 'customerService',
                apiExtend: 'sendCustomMessage',
                apiData: {
                    customerServiceId,
                    contents: inputValue
                }
            }).then(res => {
                console.log(res);
                if (res.success === true) {
                    antMessage('success', '成功', '发送成功');
                    setInputValue('');
                    if (initData) {
                        initData();
                    }
                } else {
                    antMessage('error', `发送失败，${res.message}`);
                }
            })
        }
    };

    /**
     * 扩展Props
     */
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '客服信息',
        apiId,
        columns,
        showStates: false,
        serviceId: 'business',
        showAdd: false,
        showEdit: false,
        sendPageData: { customerServiceId }
    };

    return (
        <><Space>
            <Input
                style={{ width: 300 }}
                value={inputValue}
                onChange={handleInputChange}
            ></Input>
            <Tooltip placement="topLeft"
                title={'向客人发送信息'}>
                <Button onClick={sendCustomMessage}>发送信息</Button>
            </Tooltip>
            <p></p>
        </Space>
            <WebUniversal props={extendProps} ref={ref} />
        </>
    )
}

export default Web;